import { render } from "./Completions.vue?vue&type=template&id=1b72e33c&scoped=true"
import script from "./Completions.vue?vue&type=script&lang=js"
export * from "./Completions.vue?vue&type=script&lang=js"

import "./Completions.vue?vue&type=style&index=0&id=1b72e33c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b72e33c"]])

export default __exports__